import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  sessionId: z.string().min(1),
  personaId: z.string().min(1),
  isEnabled: z.boolean(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  success: boolean;
  setting: {
    sessionId: string;
    personaId: string;
    isEnabled: boolean;
    enabledBy: number;
  };
};

export const postSessionPersonaSetting = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const result = await fetch('/_api/personas/session/update', {
    method: 'POST',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    body: superjson.stringify(input),
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }

  return superjson.parse<OutputType>(await result.text());
};
